const Show = ({ condition, children }: any) => {
  if (condition) {
    return <>{children}</>
  }
  return null
}

export default Show
